var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7fe6d7e608c1aa645adc6f850598aaf0eccdae6a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["react@eprezto"]={id:"7fe6d7e608c1aa645adc6f850598aaf0eccdae6a"};
      